import React from 'react'
import BG from '../assets/bg.png'



function Hero() {
  return (
    <>
      <div className="bg-cover bg-center h-300 w-full h-full py-80"  style={{ backgroundImage: `url(${BG})` }} id={'header'}>
          <h1 className="font-limelight md:text-9xl sm:text-6xl mx-auto text-center text-white w-1/2 py-16 bg-[#34623e]">
              LAB OF CG
          </h1>
      </div>
      <div className='bg-[#b39c4d] w-full mx-auto flex justify-center md:items-start' >
              <div className='flex w-7/12 lg:items-center lg:flex-row lg:py-28 justify-between sm:py-10 sm:flex-col pl-6'>
              <h2 className='text-[#1E2F23] font-sans sm:tracking-title md:tracking-widest font-semibold py-4 w-1/3 lg:text-4xl lg:leading-loose md:text-3xl md:w-fit md:leading-loose sm:text-2xl sm:w-fit sm:leading-loose'>
                三维图形
                <br className='md:hidden lg:block sm:hidden '>
                </br >
                实验室
              </h2>
              <div className='flex flex-col justify-start lg:w-2/5 text-28 lg:leading-loose tracking-widest font-medium sm:w-full sm:leading-loose sm:my-10'>
              <p className='w-full mb-6'>
                  深入探索图形学的奥秘，我们专注于图形学研究与教学，引领您探索虚拟与现实之间的奇妙交汇点。              </p>
              <p>
                  在这里，我们以专业精神和独特视角，开创三维图形学的新领域。实验室配备先进的设备，拥有卓越的团队，共同创建一流的学术环境和轻松的学习氛围。加入我们，一同开启三维图形学的探索之旅！
              </p>
              </div>
              </div>
          </div>
    </>

  )
}

export default Hero
